import {
  Button,
  PaginationProps,
  Table,
  Space,
  Tooltip,
  Pagination,
} from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { CONSTANT } from "../../../../config/Constant";
import {
  EditOutlined,
  DeleteOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";
interface DataType {
  company_name: string | any;
  id: string | any;
  main_id: string | any;
  icicid: string | any;
  tell: number | any;
  tell2: number | any;
  file_download_link: string | any;
  createdAt: string | any;
}
const ListComponent: React.FC<any> = (props) => {
  const {
    listData,
    savePayload,
    tableloading,
    setListData,
    setTableLoading,
    setPaginationData,
    getList,
    paginationData,
    totalData,
    handleEditModal,
    handleDeleteModal,
  } = props;

  const data: DataType[] = listData?.map((item: any, index: number) => ({
    company_name: item?.company_name ?? item?.company_name,
    id: item?.index ?? index + 1,
    main_id: item?._id,
    company_id: item?.company_id,
    tell: item?.tell,
    tell2: item?.tell2,
    address: item?.address,
    file_download_link: item?.file_download_link,
    createdAt: item?.createdAt,
    icicid: item?.icicid,
  }));

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      page_number: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      page_number: current,
      page_size: page_size,
    };
    getList(updateData);
  };
  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      page_number: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      page_number: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const columns: ColumnsType<any> = [
    {
      title: "Sr No.",
      dataIndex: "id",
      key: "id",
      width: 100,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.id?.toString().localeCompare(b?.id),
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      width: 150,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.company_name?.toString().localeCompare(b?.company_name),
      render: (_, record) => {
        return record?.company_name
          ? record?.company_name
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "ICC ID",
      dataIndex: "icicid",
      key: "icicid",
      width: 150,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.icicid?.toString().localeCompare(b?.icicid),
      render: (_, record) => {
        return record?.icicid ? record?.icicid : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Tell",
      dataIndex: "tell",
      key: "tell",
      width: 150,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.tell?.toString().localeCompare(b?.tell),
      render: (_, record) => {
        return record?.tell ? record?.tell : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Tell2",
      dataIndex: "tell2",
      key: "tell2",
      width: 150,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.tell2?.toString().localeCompare(b?.tell2),
      render: (_, record) => {
        return record?.tell2 ? record?.tell2 : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      width: 150,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.address?.toString().localeCompare(b?.address),
      render: (_, record) => {
        return record?.address ? record?.address : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.createdAt?.toString().localeCompare(b?.createdAt),
      render: (_, record) => {
        return record?.createdAt ? record?.createdAt : CONSTANT.NO_DATA_FOUND;
      },
    },

    {
      title: "Action",
      key: "action",
      width: 150,
      fixed: "right",
      render: (_, record) => {
        return (
          <Space size="middle">
            <Tooltip title={"Edit"}>
              <Button
                type="default"
                icon={<EditOutlined />}
                className="EditBtn iconBtn"
                onClick={() => handleEditModal(record)}
              />
            </Tooltip>
            <Tooltip title={"Download File"}>
              <Button
                href={record.file_download_link}
                icon={<CloudDownloadOutlined />}
                type="default"
                disabled={record.file_download_link === "" ? true : false}
                target="_blank"
                className="iconBtn"
              />
            </Tooltip>
            <Tooltip title={"Delete"}>
              <Button
                onClick={() => {
                  handleDeleteModal(record);
                }}
                icon={<DeleteOutlined />}
                type="default"
                className="cancelBtn iconBtn"
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];
  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={"fixed"}
        />
        <div className="text-center mt-20 mb-30 providerTable">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.page_number}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size ?? 10}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>
    </>
  );
};

export default ListComponent;
